// Where the Subagents pages live: /subagents on the desktop, and the same
// pages hosted at /companion/subagents on a phone (the desktop shell
// sends every phone to the companion), so links stay in the shell they
// were followed from. All runs is the list page with ?tab=runs (a
// sub-page with its own header, no tab strip).

import { useLocation } from "react-router-dom";

export function useSubagentsBase(): string {
  const { pathname } = useLocation();
  return pathname === "/companion" || pathname.startsWith("/companion/") ? "/companion/subagents" : "/subagents";
}

export function blueprintPath(base: string, template: string, view?: string): string {
  return `${base}/${encodeURIComponent(template)}${view ? `/${view}` : ""}`;
}

/** The workspace's runs (All runs), optionally with one subagent's chip. */
export function allRunsPath(base: string, template?: string | null): string {
  return `${base}?tab=runs${template ? `&blueprint=${encodeURIComponent(template)}` : ""}`;
}

// After "New subagent" → Create, the new subagent opens on its Knowledge
// settings with a one-time hint in the router state (never in the URL, so
// a reload or a shared link does not repeat it). The subagent's page reads
// it with `createdHint(location.state)`.
export const CREATED_HINT = "Add the knowledge it should use.";

export interface CreatedState {
  createdHint: string;
}

export function createdHint(state: unknown): string | null {
  const hint = (state as Partial<CreatedState> | null)?.createdHint;
  return typeof hint === "string" && hint ? hint : null;
}
